import { type ConsentVersion, type LocaleCode, CountryConfig } from "./consent";
import { MANUAL_GLOBAL_CONSENT } from "./manual-global";
import { MANUAL_KOR_CONSENT } from "./manual-kor";

/**
 * Manual consent data keyed by country code.
 * Countries not listed here fall back to the global consent.
 */
const manualConsentData: Record<string, CountryConfig> = {
  KOR: MANUAL_KOR_CONSENT,
};

/**
 * Returns the manual verification consent language based on the hiring country
 * and the locale.
 *
 * If the country has specific consent language, it is returned. Otherwise,
 * the global consent language is used.
 *
 * @param hiringCountry The country the candidate is onboarding from
 * @param locale The locale to use for the consent content
 * @returns The manual consent language to be shown to the user
 */
export const getManualConsent = (
  hiringCountry: string,
  locale?: string
): ConsentVersion => {
  const config =
    hiringCountry in manualConsentData
      ? manualConsentData[hiringCountry]
      : MANUAL_GLOBAL_CONSENT;

  if (!locale) {
    return config.content.default;
  }

  const localeCode = locale as LocaleCode;
  return config.content[localeCode] ?? config.content.default;
};
